export default [{
    path: '/administration/users',
    name: 'users-list',
    component: () => import('@/views/modules/Administration/userManagement/index.vue'),
    meta: {
      breadcrumb: [{
          text: 'userManagement.administration',
          active: false,
        },
        {
          text: 'userManagement.title',
          active: true,
        }
      ],
      unique_name: "administration-users"
    },
  },
  {
    path: '/administration/users/:id/view',
    name: 'user-view',
    component: () => import('@/views/modules/Administration/userManagement/view.vue'),
    meta: {
      breadcrumb: [{
          text: 'userManagement.administration',
          to: '/administration/users',
          active: false,
        },
        {
          text: 'userManagement.title',
          active: true,
        }
      ],
      unique_name: "administration-users"
    },
  },
  {
    path: '/administration/my-profile',
    name: 'profile-view',
    component: () => import('@/views/modules/Administration/userManagement/view.vue'),
    props: true,
    meta: {
      breadcrumb: [{
          text: 'userManagement.administration',
          to: '/administration/users',
          active: false,
        },
        {
          text: 'userManagement.my_profile',
          active: true,
        }
      ],
      unique_name: ""
    },
  },
  {
    path: '/administration/permissions',
    name: 'permissions',
    component: () => import('@/views/modules/Administration/Permission/Permission.vue'),
    meta: {
      breadcrumb: [{
        text: 'permissions',
        active: true,
      }, ],
      unique_name: "administration-permissions"
    },
  },
  {
    path: '/administration/permissions/:role',
    name: 'permissions_details',
    component: () => import('@/views/modules/Administration/Permission/PermissionDetails.vue'),
    meta: {
      breadcrumb: [{
          text: 'permissions',
          active: false,
          to: '/administration/permissions',
        },
        {
          text: 'permissions_details',
          active: true,
        },
      ],
      unique_name: "administration-permissions"
    },
  },
]